import { useLocation, useNavigate } from 'react-router-dom';
import { ChecklistUploadPage } from './ChecklistUploadPage';
import { DevicesPage } from './DevicesPage';
import { HelpInsightsPage } from './HelpInsightsPage';
import { OperationsPage } from './OperationsPage';

type AdminSection = 'Devices' | 'Checklists' | 'Help Insights' | 'Operations';

export const ADMIN_SECTIONS: readonly AdminSection[] = [
  'Checklists',
  'Operations',
  'Help Insights',
  'Devices',
];

export function adminSectionFromPath(pathname: string): AdminSection {
  if (pathname.startsWith('/admin/devices')) return 'Devices';
  if (pathname.startsWith('/admin/help-insights')) return 'Help Insights';
  if (pathname.startsWith('/admin/operations')) return 'Operations';
  return 'Checklists';
}

function adminSectionPath(section: AdminSection): string {
  if (section === 'Devices') return '/admin/devices';
  if (section === 'Help Insights') return '/admin/help-insights';
  if (section === 'Operations') return '/admin/operations';
  return '/admin';
}

export function AdminPage(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();
  const section = adminSectionFromPath(location.pathname);
  const wallboard = new URLSearchParams(location.search).get('display') === 'wallboard';

  if (section === 'Operations' && wallboard) return <OperationsPage />;

  return (
    <div>
      <h2>Admin</h2>
      <div className="tcvs-storage-layout">
        <nav className="tcvs-storage-nav" aria-label="Admin sections">
          <div className="tcvs-storage-nav-group">
            <div className="tcvs-storage-nav-heading">Admin</div>
            {ADMIN_SECTIONS.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => navigate(adminSectionPath(item))}
                aria-current={item === section ? 'page' : undefined}
                className={
                  item === section
                    ? 'tcvs-storage-nav-item tcvs-storage-nav-item-active'
                    : 'tcvs-storage-nav-item'
                }
              >
                {item}
              </button>
            ))}
          </div>
        </nav>
        <div className="tcvs-storage-content">
          {section === 'Devices' ? <DevicesPage /> : null}
          {section === 'Checklists' ? <ChecklistUploadPage /> : null}
          {section === 'Help Insights' ? <HelpInsightsPage /> : null}
          {section === 'Operations' ? <OperationsPage /> : null}
        </div>
      </div>
    </div>
  );
}
